import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ScrollReveal } from '../components/ScrollReveal';
const categories = ['All', 'Branding', 'Social Media', 'Content'];
const portfolioItems = [{
  id: 1,
  title: 'Artisan Coffee Co.',
  category: 'Branding',
  bg: 'bg-sage'
}, {
  id: 2,
  title: 'Elevate Fitness',
  category: 'Social Media',
  bg: 'bg-teal/20'
}, {
  id: 3,
  title: 'Lumina Skincare',
  category: 'Content',
  bg: 'bg-coral/20'
}, {
  id: 4,
  title: 'The Daily Edit',
  category: 'Social Media',
  bg: 'bg-white/60'
}, {
  id: 5,
  title: 'Haven Interiors',
  category: 'Branding',
  bg: 'bg-sage/60'
}, {
  id: 6,
  title: 'Urban Roots',
  category: 'Content',
  bg: 'bg-teal/30'
}, {
  id: 7,
  title: 'Sola Boutique',
  category: 'Social Media',
  bg: 'bg-coral/30'
}, {
  id: 8,
  title: 'Vertex Tech',
  category: 'Branding',
  bg: 'bg-sage/40'
}];
export function PortfolioPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredItems = portfolioItems.filter(item => activeCategory === 'All' ? true : item.category === activeCategory);
  return <div className="w-full pt-32 pb-24 px-6 md:px-12" data-id="element-266">
      <div className="max-w-7xl mx-auto" data-id="element-267">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-268">
          <ScrollReveal data-id="element-269">
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-teal mb-6" data-id="element-270">
              Our Work
            </h1>
            <p className="text-xl text-teal/80" data-id="element-271">
              A curated collection of our work across content creation,
              branding, and social media.
            </p>
          </ScrollReveal>
        </div>

        {/* Filters */}
        <ScrollReveal delay={0.2} data-id="element-272">
          <div className="flex flex-wrap justify-center gap-4 mb-16" data-id="element-273">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-6 py-2 rounded-full text-sm font-semibold transition-all ${activeCategory === category ? 'bg-teal text-cream' : 'bg-white/50 text-teal hover:bg-white'}`} data-id="element-274">
                {category}
              </button>)}
          </div>
        </ScrollReveal>

        {/* Grid */}
        <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-275">
          <AnimatePresence data-id="element-276">
            {filteredItems.map(item => <motion.div key={item.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} className={`aspect-square rounded-3xl ${item.bg} relative overflow-hidden group cursor-pointer border border-teal/5`} data-id="element-277">
                <motion.div initial={{
              opacity: 0
            }} whileHover={{
              opacity: 1
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 bg-teal/90 flex flex-col items-center justify-center p-8 text-center" data-id="element-278">
                  <span className="text-sage font-medium mb-3 tracking-wider text-sm uppercase" data-id="element-279">
                    {item.category}
                  </span>
                  <h3 className="text-3xl font-heading font-bold text-white" data-id="element-280">
                    {item.title}
                  </h3>
                  <div className="mt-6 w-10 h-10 rounded-full border border-white/30 flex items-center justify-center text-white group-hover:bg-coral group-hover:border-coral transition-colors" data-id="element-281">
                    +
                  </div>
                </motion.div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>;
}